<template>
  <div></div>
</template>

<script setup>
import { onMounted } from "vue";

const props = defineProps({
  pixel: {
    type: [Object, String], // Permitimos Object o String para más flexibilidad
    default: undefined
  },
  type: {
    type: String,
    default: undefined
  }
});

onMounted(() => {
  if (window.twq) {
    // Usamos el ID del evento desde props.pixel si existe, o el valor por defecto
    const eventId = props.pixel?.eventId || props.pixel || "tw-or3pj-p7wab";
    twq("event", eventId, {
      // Add any additional parameters here if needed
    });
  } else {
    console.warn("Twitter Pixel not initialized");
  }
});
</script>

<style scoped></style>
